import { useDispatch } from 'react-redux';
import { addInfoToast } from 'modules/toastContainer';
import { useTranslation } from '../../../hooks';

export const useDisplayNewStaticListToast = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return () => {
    dispatch(addInfoToast(t('toast.newList.info')));
  };
};
